import React, { Component } from 'react'

import PaneWrapper from './PaneWrapper'
import PaneHeader from './PaneHeader'
import PaneList from './PaneList'

export default class Pane extends Component {

  static propTypes = {

  }

  /* :: props: Props */

  render() {
    return (
      <PaneWrapper>
        <PaneHeader />
        <PaneList />
      </PaneWrapper>
    )
  }

}



// WEBPACK FOOTER //
// ./src/user/components/Pane.js